import './mailings';
import './mailings-list';
import './mailings-edit';
import './mailingFilesStelaModal';
import './mailingTemplatesModal';